import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const hetzner = defineConnector({
  identifier: "hetzner",
  name: "Hetzner Cloud",
  tagLine: "Cloud hosting provider",
  logo,
  protocol: "http",
  tags: ["it", "engineering"],
  defaultUrlPattern: () => "https://api\\.hetzner\\.cloud/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an API token",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Hetzner Cloud Console](https://console.hetzner.cloud/), select a project, navigate to **Security > API Tokens**, and generate a new token.",
        },
      ],
    },
    {
      title: "Copy and paste the API token into the field below",
      items: [
        {
          kind: "input",
          label: "API token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.hetzner.cloud/v1/servers",
  },
});
